<template>
<div class="chapter">
<div class="inner_page">
<p class="break"> </p>
<p class="toc">CONTENTS</p>
<p class="tocitem"><a href="#/html/06_foreword" id="tocf">Foreword</a></p>
<p class="tocitem"><a href="#/html/07_preface" id="tocp">Preface</a></p>
<p class="tocitem1"><span href="#/html/08_chap1#c1" id="toc1" title="Link target outside of Sample"><span class="tocnum">1:</span>The Crisis of Catholic Education: A History with a Lesson</span></p>
<p class="tocitem1"><span href="#/html/09_chap2#c2" id="toc2" title="Link target outside of Sample"><span class="tocnum">2:</span>The Schools and Our Children: No Passing Grade</span></p>
<p class="tocitem1"><span href="#/html/10_chap3#c3" id="toc3" title="Link target outside of Sample"><span class="tocnum">3:</span>The Purposes of Education: Happiness, Culture, Virtue</span></p>
<p class="tocitem1"><span href="#/html/11_chap4#c4" id="toc4" title="Link target outside of Sample"><span class="tocnum">4:</span>The Methods of the Teacher: Imitation before Invention</span></p>
<p class="tocitem1"><span href="#/html/12_chap5#c5" id="toc5" title="Link target outside of Sample"><span class="tocnum">5:</span>The Matter of Learning: The Sprightly Seven Arts</span></p>
<p class="tocitem1"><span href="#/html/13_chap6#c6" id="toc6" title="Link target outside of Sample"><span class="tocnum">6:</span>The Coming Renewal: Faith in the Future</span></p>
<p class="tocitem2"><span href="#/html/14_appendix1" id="toca1" title="Link target outside of Sample">Appendix 1: Discussion Questions</span></p>
<p class="tocitem"><span href="#/html/15_appendix2" id="toca2" title="Link target outside of Sample">Appendix 2: Guide to Further Study</span></p>
<p class="tocitem"><span href="#/html/16_endnotes" id="tocn" title="Link target outside of Sample">Endnotes</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_contents.vue?71cd8ca0